/* eslint-disable no-useless-constructor */
import React from 'react';
import demoBase64 from '../../../mock/demoBase64';
import Female from '../../../asset/img/female-icon.png';
import Male from '../../../asset/img/male-icon.png';

class Manager extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { manager } = this.props;


    return (
      <li>
        <div className="row">
          <div className="col-xs-2">
            <div className="avatar">
              <img
                src={manager.gender === 'Male' ? Male : manager.gender === 'Female' ? Female : demoBase64}
                alt="Avatar"
                className="img-circle img-no-padding img-responsive"
              />
            </div>
          </div>
          <div className="col-xs-8" style={{ padding: '15px 15px 15px 25px' }}>
            <span style={{ fontSize: '14px' }}>
              {manager.managerName}
            </span>
            <br />
            <span className="text-muted">
              <small>
                {manager.unitName}
              </small>
            </span>
          </div>
          <div className="col-xs-2" style={{ padding: '10px 20px 10px 10px' }}>
            <a
              href={`mailto:${manager.managerMail}`}
              className="btn btn-sm btn-success btn-icon"
            >
              <i className="fa fa-envelope" />
            </a>
          </div>
        </div>
      </li>
    );
  }
}

export default Manager;



// WEBPACK FOOTER //
// ./src/components/manager/list-item/index.js